import { render, staticRenderFns } from "./FiltersAdd.vue?vue&type=template&id=268c2a82"
import script from "./FiltersAdd.vue?vue&type=script&lang=js"
export * from "./FiltersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports